<app-colored-background [backgroundColor]="'#0193A9'">
  <app-header [progress]="1" [title]="locale.currentTranslation.informationHeader" [showProgressIndicator]="false"
              [useWhiteFontColor]="true"></app-header>
  <div>
    <div class="base-content-container" style="gap:0;">
      <div>
        <div class="headline1" style="color: #FFFFFF">
          {{ locale.currentTranslation.yourDuty}}
        </div>
        <div class="text-body1" style="color: #FFFFFF;">
          <div>
            {{locale.currentTranslation.dutyInformation1}}
          </div>
          <div style="margin-top: 21px;">
            {{locale.currentTranslation.dutyInformation2}}
          </div>
        </div>
      </div>
    </div>
    <app-finish-box></app-finish-box>
    <div class="main-button-spacing">
      <button class="main-button" data-testid="btn-next" routerLink="/quick-response-info">{{ locale.currentTranslation.next }}</button>
    </div>
  </div>

  <app-footer></app-footer>
</app-colored-background>
